import React from "react";

import { ROUTES } from "~/router";
import { ProviderSelectionView } from "~/screens/Hub/BookVisit/views/ProviderSelection/components/ProviderSelectionView";
import { useVisitType } from "~/screens/Scheduling/PersonalInformation/hooks/use-visit-type";
import { usePageTitle, useRedirect } from "~/shared";
import { usePatientStore } from "~/stores/use-patient-store";

export const SchedulingProviderSelection = () => {
  usePageTitle("Provider Selection");

  const redirect = useRedirect();
  const { visitType } = useVisitType();
  const { patientVisitData } = usePatientStore();

  const setSelectedProvider = usePatientStore(
    (state) => state.setSelectedProvider,
  );

  const handleProviderSelect = (providerId: number) => {
    setSelectedProvider(providerId);
    redirect(ROUTES.hubMeetProviderAppointments);
  };

  const handleGoBack = () => {
    redirect(ROUTES.getStartedInsurance);
  };

  return (
    <ProviderSelectionView
      handleProviderSelect={handleProviderSelect}
      stateId={patientVisitData?.patientStateId}
      insuranceId={patientVisitData?.insuranceId}
      visitType={visitType}
      handleGoBack={handleGoBack}
    />
  );
};
